export var debugId = "endpoints";